import React from 'react';
import Framework from "@beardeddevops/react.framework";
import {Objects} from "components";

const breadcrumbsStatic = [
	{
		name: 'Dashboard',
		url: '/',
		icon: 'dashboard',
	},
	{
		name: 'ERP',
		url: '/erp',
		icon: 'industry',
	},
	{
		name: 'Job Tracker',
		url: '/erp/job-tracker',
		icon: 'tasks',
	},
];

export default class MrpJobTracker extends Framework.Components.View {
	render() {
		return (
			<div className="container-fluid">
				<Framework.Components.PageBar
					breadcrumbs={breadcrumbsStatic}
					history={this.props.history}
				/>
				<Objects.MrpJobTracker history={this.props.history}/>
			</div>
		);
	}
}
